import { BaseObject } from "../../../core/business-objects/base-object/base-object.model";
import { BaseObjectFilters } from "../bootstrap";
import { VasState } from "../store-type";
import { getFilterBySearchTermFn } from "../../../core/util/search-and-sort";
import { createSelector } from "reselect";
import { itemSelector, listSelector } from "../../business-objects/query-facade";
import { IPageFilter } from "./page-filter.interface";

export class PageFilter<T extends BaseObject, F extends BaseObjectFilters> implements IPageFilter<T, F> {

    createSelector(itemsSelector: listSelector<T>, filterSelector: itemSelector<F>): (state: VasState) => Array<T> {

        return createSelector(
            itemsSelector,
            filterSelector,
            (items, filters) => items.filter(getFilterBySearchTermFn(filters.searchTerm))
        );
    }
}



// WEBPACK FOOTER //
// ./src/vas/store/queries/page-filter.ts